const exit = (router) => {
  router.push("/");
};

export default exit;
